import * as permissionData from './permissionData';

export const wixDataConstants = {
  permissionData,
};
